module.exports = "/_next/static/images/760989cc3c5b719a6fa799c65c4e71ef-two-people-looking-lg@2x.jpg.webp";